let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gbPQG")).then(() => parcelRequire('9gjfb'));